import { render, staticRenderFns } from "./CollectionIssueEventDetailsDialog.vue?vue&type=template&id=e28e9182&"
import script from "./CollectionIssueEventDetailsDialog.vue?vue&type=script&lang=ts&"
export * from "./CollectionIssueEventDetailsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionIssueEventDetailsDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCard,VCardTitle,VDialog,VIcon,VImg,VSkeletonLoader})
